import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import CoreThemes from '../components/CoreThemes';
import Author from '../components/Author';
import Listen from '../components/Listen';

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <About />
      <CoreThemes />
      <Author />
      <Listen />
    </div>
  );
};

export default Home;
